<template>
  <div class="px-30 py-10" ref="raytingTab">
    <div class="row gx-15">
      <div class="col-6">
        <div class="system-block" style="height: 624px;">
          <p class="fw-bolder fsc-12 mb-10 text-dark">
            {{ dataLang['vehicle_modal_rayting_text5'] }}
          </p>
          <table class="rating-table">
            <tr>
              <td style="width: 20%">
                {{ dataLang['clients_register_text_74'] }}
              </td>
              <td style="width: 20%">
                {{ dataLang['clients_register_text_75'] }}
              </td>
              <td style="width: 60%">
                {{ dataLang['clients_register_text_76'] }}
              </td>
            </tr>
            <tr v-for="item of ratingList" :key="item.vehicle_rayting__id">
              <td>{{ item.vehicle_rayting__contract_id }}</td>
              <td style="padding: 16px 19px;">
                <div style="display: flex; gap: 3px; justify-content: center;">
                  <svg v-for="(rating, index) of item.vehicle_rayting__rayting" :key="index" width="13" height="12"
                    viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M5.16303 0.874816C5.52984 0.131571 6.58968 0.131572 6.9565 0.874818L8.03129 3.05258C8.17695 3.34772 8.45851 3.55229 8.78422 3.59962L11.1875 3.94884C12.0077 4.06802 12.3353 5.07599 11.7417 5.65453L10.0027 7.34968C9.76701 7.57942 9.65946 7.91042 9.7151 8.23481L10.1256 10.6284C10.2657 11.4453 9.40831 12.0683 8.67468 11.6826L6.5251 10.5525C6.23378 10.3993 5.88575 10.3993 5.59442 10.5525L3.44485 11.6826C2.71122 12.0683 1.85378 11.4453 1.99389 10.6284L2.40443 8.23481C2.46007 7.91042 2.35252 7.57942 2.11683 7.34968L0.377788 5.65453C-0.215729 5.076 0.11178 4.06802 0.932001 3.94884L3.3353 3.59962C3.66101 3.55229 3.94258 3.34772 4.08824 3.05258L5.16303 0.874816Z"
                      fill="#F5B704" />
                  </svg>
                </div>
              </td>
              <td>{{ item.vehicle_rayting__comment }}</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="col-6">
        <div class="system-block h-100">
          <div class="row gx-30 mb-15">
            <div class="col-6">
              <div
                class="bg-confirmation d-flex justify-content-center align-items-center rounded-5 text-center fw-bold text-white"
                style="height: 195px; font-size: 96px">
                {{ currentRayting }}
              </div>
            </div>
            <div class="col-6">
              <div class="d-flex align-items-center text-dark fw-semi-bold"
                style="height: 195px; font-size: 50px; line-height: 62.5px">
                {{ dataLang['vehicle_modal_rayting_text1'] }}
              </div>
            </div>
          </div>
          <p class="fsc-14 mb-30">
            {{ dataLang['vehicle_modal_rayting_text2'] }}
          </p>
          <div class="bg-system-secondary px-30 py-15 text-dark fsc-14">
            <p class="mb-0 fw-semi-bold">
              {{ dataLang['vehicle_modal_rayting_text3'] }}
            </p>
            <span>{{ dataLang['vehicle_modal_rayting_text4'] }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
import ObjectsService from '@/api/ObjectsService'

import AddNewTriesModal from '@/components/vehicles-page-single-modal-inner/AddNewTriesModal.vue'
import httpInstance from '@/http-common.js'
import GeneralService from '@/api/GeneralService'
//   import ObjectsService from '@/api/ObjectsService'
//   import EventBus from '@/event-bus.js'
//   import SingleModal from '@/components/SingleModal.vue'
export default {
  components: {
    AddNewTriesModal
  },
  props: {
    modeOpenModal: {
      type: String,
      default: 'create'
    },

    currentOpenedId: {
      type: Number
    }
  },
  data() {
    return {
      loadingState: true,
      ratingList: [],
      currentRayting: 0
    }
  },
  methods: {
    sendData(callback, nameTab, oldTab, newTab, flagIsClose) {
      callback(true, nameTab, oldTab, newTab, flagIsClose)
    },
    ...mapActions('transportVehiclesModule', ['getHealth', 'getTitle'])
  },
  created() {
    this.$emit('loadingModal', true)
    this.getHealth(this.currentOpenedId)
    this.getTitle(this.currentOpenedId)

    Promise.all([
      GeneralService.get(`/objects/${this.currentOpenedId}/rayting`)
        .then((data) => {
          this.currentRayting = data.data.data.rayting
          this.ratingList = data.data.data.marks
        })
        .catch((e) => {
          console.error(e)
          if (e?.response) {
            this.$toast.error(e?.response.data.message, { duration: 5000 })
          } else {
            this.$toast.error('ERROR GET RATING', { duration: 5000 })
          }
        })
    ]).then(() => {
      this.$emit('loadingModal', false)
      this.loadingState = false
    })
  },
  computed: {
    ...mapState('translationModule', ['dataLang'])
  }
}
</script>
